module.exports = __webpack_public_path__ + "static/media/dashboard-kudos-close-icon.d23301b6.svg";